exports = module.exports = require("../../../../../../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.add-goods-form {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.add-goods-form .el-form-item {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.add-goods-form .el-form-item .el-form-item__label {\n      width: 76px;\n}\n.add-goods-form .goods-item .el-input__inner {\n    height: 40px !important;\n}\n.add-goods-form .goods-weight-item {\n    padding: 0 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?{"sourceMap":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5805dee4","scoped":false,"hasInlineConfig":false}!./node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/views/personal/deliver/components/handlingWrapper/components/addGoodsDialog/index.vue
// module id = fg3d
// module chunks = 1